<template>
  <div id="scale_type">
    <a-tabs default-active-key="0" @change="callback" type="card">
      <template v-for="(item, index) in typeList">
        <a-tab-pane :key="`${index}`" :tab="item">
          <a-table :columns="columns" :data-source="scaleArr" :rowKey="row => row.ID" :pagination="{ pageSize: 5 }" :locale="locale">
            <template slot="SURVEY_TITLE" slot-scope="text, record">
              <div style="display: flex; align-items: center;">
                <img v-if="record.RIGHT" src="@/assets/drawer_icon.png" alt="" style="width: 16px; height: auto; margin-right: 8px;">
                <img v-else src="@/assets/drawer_icon_two.png" alt="" style="width: 16px; height: auto; margin-right: 8px;">
                <span :style="{color: record.RIGHT ? '#262626' : '#D9D9D9'}">{{text}}</span>
              </div>
            </template>
            <template slot="SURVEY_NUM" slot-scope="text, record">
              <span :style="{color: record.RIGHT ? '#262626' : '#D9D9D9'}">{{text ? `${text}题` : ''}}</span>
            </template>
            <template slot="SURVEY_TIME" slot-scope="text, record">
              <span :style="{color: record.RIGHT ? '#262626' : '#D9D9D9'}">{{text ? `${text}分钟` : ''}}</span>
            </template>
            <template slot="ADAPTER_NUM" slot-scope="text, record">
              <div v-if="text === '1'" class="port_box">
                <span :style="{opacity: record.RIGHT ? 1 : 0.3}">电脑端</span>
              </div>
              <div v-else class="port_box_two">
                <span :style="{opacity: record.RIGHT ? 1 : 0.3}">电脑端</span>
                <span :style="{opacity: record.RIGHT ? 1 : 0.3}">手机端</span>
              </div>
            </template>
            <template slot="Action_btn" slot-scope="text, record">
              <span v-if="record.RIGHT && roleID === 1" @click="createHand(record)" style="color: #51BF94; cursor: pointer; margin-right: 16px;">创建测评任务</span>
              <a-tooltip v-else>
                <template slot="title" v-if="roleID === 1">该量表还未开通</template>
                <template slot="title" v-else>仅限超级管理员使用</template>
                <span style="color: #D9D9D9; cursor: pointer; margin-right: 16px;">创建测评任务</span>
              </a-tooltip>
              <span @click="previewHand(record)" style="color: #51BF94; cursor: pointer;">题目预览</span>
            </template>
          </a-table>
        </a-tab-pane>
      </template>
    </a-tabs>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import ScaleTitlePreview from '@/util/scaleTitlePreview'

export default {
  name: 'ScaleType',
  data () {
    return {
      typeList: ['心理健康', '学习相关', '能力与人格', '人际交往', '压力应对与适应', '自我认识与发展', '职业倾向', '家庭', '问题行为', '亲子沟通'],
      columns: [
        {
          title: '量表名称',
          dataIndex: 'SURVEY_TITLE',
          scopedSlots: { customRender: 'SURVEY_TITLE' },
        },
        {
          title: '题目数量',
          dataIndex: 'SURVEY_NUM',
          scopedSlots: { customRender: 'SURVEY_NUM' },
        },
        {
          title: '预计用时',
          dataIndex: 'SURVEY_TIME',
          scopedSlots: { customRender: 'SURVEY_TIME' },
        },
        {
          title: '适配端口',
          dataIndex: 'ADAPTER_NUM',
          scopedSlots: { customRender: 'ADAPTER_NUM' },
        },
        {
          title: '操作',
          dataIndex: 'Action_btn',
          scopedSlots: { customRender: 'Action_btn' },
        }
      ],
      scaleArr: null,
      roleID: null,
      city: null,
      locale: {
        emptyText: '量表库正在更新中，敬请期待！'
      }
    }
  },
  computed: {
    ...mapState([
      'allSurveys'
    ])
  },
  async mounted () {
    this.roleID = JSON.parse(sessionStorage.getItem('userInfo')).role_id
    this.city = JSON.parse(sessionStorage.getItem('userInfo')).city
    await this.getAllSurveys()
    this.scaleArr = this.allSurveys.filter(item => item.CATEGORY_TITLE === this.typeList[0])
  },
  methods: {
    ...mapActions([
      'getAllSurveys',
      'getGradeClass'
    ]),
    ...mapMutations([
      'setDistributeItem'
    ]),
    callback (key) {
      this.scaleArr = this.allSurveys.filter(item => item.CATEGORY_TITLE === this.typeList[key])
    },
    async createHand (key) {
      await this.getGradeClass()
      this.setDistributeItem({type: 0, ID: key.ID, SURVEY_TITLE: key.SURVEY_TITLE})
      this.$router.push('/evaluationList/distributionDetail')
    },
    previewHand (key) {
      const url = ScaleTitlePreview(key.ID, this.city)
      window.open(url)
    }
  }
}
</script>

<style>
#scale_type {
  width: 100%;
  border-bottom: 1px solid #E8E8E8;
  border-left: 1px solid #E8E8E8;
  border-right: 1px solid #E8E8E8;
}
#scale_type .ant-tabs-nav .ant-tabs-tab {
  margin: 0px;
}
#scale_type .ant-tabs-bar {
  margin: 0px;
}
#scale_type .port_box span, #scale_type .port_box_two span {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 2px;
  box-sizing: border-box;
}
#scale_type .port_box span:first-child, #scale_type .port_box_two span:first-child {
  color: #1890FF;
  margin-right: 8px;
  background-color: #E6F7FF;
  border: 1px solid #91D5FF;
}
#scale_type .port_box_two span:last-child {
  color: #52C41A;
  background-color: #F6FFED;
  border: 1px solid #B7EB8F;
}
#scale_type .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab:first-child {
  border-left: none;
}
#scale_type .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab:last-child {
  border-right: none;
}
#scale_type .ant-pagination {
  padding: 0px 20px 0px 0px;
}
#scale_type .ant-table-placeholder {
  padding: 80px 16px;
}
</style>
